import { createReducer } from "typesafe-actions";
import { menuAction } from "./sagas";

export interface MenuReducerState {
  selectedDatakey: string;
  openingDatakeys: string[];
}

const initalState: MenuReducerState = {
  selectedDatakey: "",
  openingDatakeys: []
};

export const menuReducer = createReducer<MenuReducerState>(initalState)
  .handleAction(
    menuAction,
    (state: MenuReducerState, action: any): MenuReducerState => {
      return {
        ...state,
        ...action.payload
      };
    }
  );
